{
  "jira.nin.saved.filters.menu.spotlight.body": [
    {
      "type": 0,
      "value": "Find filters you've saved, and save new ones in one place."
    }
  ],
  "jira.nin.saved.filters.menu.spotlight.dismiss": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.nin.saved.filters.menu.spotlight.title": [
    {
      "type": 0,
      "value": "Finding and creating saved filters just got easier"
    }
  ]
}